module.exports = __webpack_public_path__ + "themify.a1ecc3b826d01251eddd.woff";


//////////////////
// WEBPACK FOOTER
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/assets/scss/icons/themify-icons/fonts/themify.woff
// module id = ../../../../../src/assets/scss/icons/themify-icons/fonts/themify.woff
// module chunks = styles